import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./dashboard/Dashboard";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SetupPassword from "./pages/SetupPassword";
import Company from "./dashboard/pages/Company";
import Users from "./dashboard/pages/Users";
import Profile from "./dashboard/pages/Profile";
import API from "./dashboard/pages/API";
import Integration from "./dashboard/pages/Integration";
import GhlManage from "./dashboard/pages/GhlManage";
import Devices from "./dashboard/pages/Devices";
import MobileApp from "./dashboard/pages/MobileApp";
import Billing from "./dashboard/pages/Billing";
import Chat from "./dashboard/pages/Chat";
import WhatsApp from "./dashboard/pages/WhatsApp";
import IMessage from "./dashboard/pages/IMessage";
import Services from "./dashboard/pages/Services";
import Plans from "./dashboard/pages/Plans";
import BillingSuccess from "./pages/BillingSuccess";
import BillingCancel from "./pages/BillingCancel";
import Header from "./components/Header";
import Footer from "./components/Footer";
import OpsLayout from "./ops/OpsLayout";
import OpsOverview from "./ops/pages/OpsOverview";
import OpsCompanies from "./ops/pages/OpsCompanies";
import OpsAnnouncements from "./ops/pages/OpsAnnouncements";
import OpsUsers from "./ops/pages/OpsUsers";
import OpsIMessage from "./ops/pages/OpsIMessage";
import OpsBilling from "./ops/pages/OpsBilling";
import OpsAuditLogs from "./ops/pages/OpsAuditLogs";
import OpsMobileReleases from "./ops/pages/OpsMobileReleases";
import OpsEmailSettings from "./ops/pages/OpsEmailSettings";
import OpsAnalytics from "./ops/pages/OpsAnalytics";
import OpsPartners from "./ops/pages/OpsPartners";
import { NotifyHost } from "./components/Notify";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error, info) {
    console.error("App crash:", error, info?.componentStack);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, textAlign: "center", fontFamily: "sans-serif" }}>
          <h2>Something went wrong</h2>
          <p>Please refresh the page or contact support.</p>
          <button onClick={() => window.location.reload()} style={{ padding: "8px 20px", cursor: "pointer" }}>
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function GuestOnly({ children }) {
  const token = localStorage.getItem("userToken");
  if (token) {
    const role = (localStorage.getItem("userRole") || "").toLowerCase();
    const dest = role === "support" || role === "superadmin" ? "/ops/overview" : "/dashboard";
    return <Navigate replace to={dest} />;
  }
  return children;
}

export default function App() {
  return (
    <ErrorBoundary>
    <NotifyHost />
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Navigate replace to="/login" />} />
        <Route path="/login" element={<GuestOnly><div className="pf-guest"><Header /><Login /><Footer /></div></GuestOnly>} />
        <Route path="/signup" element={<GuestOnly><div className="pf-guest"><Header /><Signup /><Footer /></div></GuestOnly>} />
        <Route path="/verify-email" element={<div className="pf-guest"><Header /><VerifyEmail /><Footer /></div>} />
        <Route path="/forgot-password" element={<div className="pf-guest"><Header /><ForgotPassword /><Footer /></div>} />
        <Route path="/reset-password" element={<div className="pf-guest"><Header /><ResetPassword /><Footer /></div>} />
        <Route path="/setup-password" element={<div className="pf-guest"><Header /><SetupPassword /><Footer /></div>} />

        {/* Company Portal */}
        <Route path="/dashboard/*" element={<Dashboard />} />
        <Route path="/company" element={<Company />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/users" element={<Users />} />
        <Route path="/mobile-app" element={<MobileApp />} />
        <Route path="/api" element={<API />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/whatsapp" element={<WhatsApp />} />
        <Route path="/imessage" element={<IMessage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/integration" element={<Integration />} />
        <Route path="/integration/ghl" element={<GhlManage />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/billing/success" element={<BillingSuccess />} />
        <Route path="/billing/cancel" element={<BillingCancel />} />

        <Route path="/ops/*" element={<OpsLayout />}>
          <Route index element={<Navigate replace to="overview" />} />
          <Route path="overview" element={<OpsOverview />} />
          <Route path="analytics" element={<OpsAnalytics />} />
          <Route path="companies" element={<OpsCompanies />} />
          <Route path="partners" element={<OpsPartners />} />
          <Route path="users" element={<OpsUsers />} />
          <Route path="imessage" element={<OpsIMessage />} />
          <Route path="audit-log" element={<OpsAuditLogs />} />
          <Route path="announcements" element={<OpsAnnouncements />} />
          <Route path="billing" element={<OpsBilling />} />
          <Route path="mobile-releases" element={<OpsMobileReleases />} />
          <Route path="email-settings" element={<OpsEmailSettings />} />
        </Route>
      </Routes>
    </Router>
    </ErrorBoundary>
  );
}
